import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import {
  Option,
  Title,
  InputBox,
  Separator,
} from "../../accessories/accessories";
import Dropdown from "../../accessories/DropDown";
import { web, android, ios } from "../../accessories/Platform";
import {
  cleanValue,
  formatDateTimeNew,
  log,
} from "../../accessories/CommonFunctions";
import CustomText from "../../accessories/CustomText";
import CheckBoxSelection from "../../accessories/CheckBoxSelection";
import AddressAutocomplete from "../../accessories/GooglePlacesAutoComplete";
import AddressAutocompleteApp from "../../accessories/GooglePlacesAutoCompleteApp";

const Income = ({ detailsArr, handleOptionPress }) => {
  detailsArr["subFields"] = detailsArr["subFields"]?.filter((e) => e !== null);
  const typeTwoFields =
    detailsArr["subFields"]?.length > 0 ? detailsArr["subFields"] : [];

  return (
    <View>
      <Title text={detailsArr["Title"]} />
      <View>
        <View
          style={
            detailsArr["widthOption"] !== undefined
              ? { flexDirection: "row", justifyContent: "space-around" }
              : { flex: 1 }
          }
        >
          {detailsArr["Options"]?.map((item, index) => (
            <Option
              key={index}
              style={
                detailsArr["widthOption"] !== undefined
                  ? { width: detailsArr["widthOption"] }
                  : {}
              }
              text={item["text"]}
              value={item["value"] === detailsArr["ColumnValue"]}
              onPress={() =>
                handleOptionPress(
                  item["value"],
                  null,
                  null,
                  null,
                  detailsArr["ColumnName"] === "CurrentlyEmployed"
                    ? detailsArr["ColumnName"]
                    : null
                )
              }
            />
          ))}
        </View>
      </View>
      {typeTwoFields?.length > 0 && (
        <>
          <View>
            {typeTwoFields?.map((item, index) => (
              <View key={index}>
                <Title
                  text={item["Title"]}
                  style={{ marginBottom: item["type"] === 1 ? 10 : 15 }}
                />
                {item["type"] === 2 ? (
                  <InputBox
                    keyboardType={item["keyboardType"]}
                    maxLength={item["maxLength"]}
                    forceValidation={item["forceValidation"]}
                    isCurrency={item["isCurrency"]}
                    label={
                      item["label"] === "Employed To" ? (
                        <TouchableOpacity
                          activeOpacity={1}
                          onPress={() => {
                            if (detailsArr["onChangeText"])
                              detailsArr["onChangeText"](
                                item["ColumnName"],
                                formatDateTimeNew(new Date().toISOString(), 2)
                              );
                            else
                              handleOptionPress(
                                formatDateTimeNew(new Date().toISOString(), 2),
                                true,
                                index
                              );
                          }}
                          style={{
                            width: web ? 150 : 150,
                            height: web ? "auto" : 20,
                            // borderWidth: 1,
                          }}
                        >
                          <CustomText
                            style={{
                              position: "absolute",
                              backgroundColor: "#fff",
                              top: web ? -12 : 0,
                              left: 3,
                              fontSize: 14,
                              color: "gray",
                              paddingHorizontal: 3,
                            }}
                            bold={!web}
                          >
                            {item["label"]}
                          </CustomText>
                          <TouchableOpacity
                            activeOpacity={1}
                            onPress={() => {
                              if (detailsArr["onChangeText"])
                                detailsArr["onChangeText"](
                                  item["ColumnName"],
                                  formatDateTimeNew(new Date().toISOString(), 2)
                                );
                              else
                                handleOptionPress(
                                  formatDateTimeNew(
                                    new Date().toISOString(),
                                    2
                                  ),
                                  true,
                                  index
                                );
                            }}
                            style={[
                              styles.optionContainer,
                              {
                                left: 100,
                                top: web ? -12 : 6,
                                // width: 55,
                                // height: 25,
                                // position: "absolute",
                              },
                            ]}
                          >
                            <CustomText style={styles.optionText}>
                              Today
                            </CustomText>
                          </TouchableOpacity>
                        </TouchableOpacity>
                      ) : (
                        item["label"]
                      )
                    }
                    disabled={item["disabled"] || false}
                    validate={item["isValid"] || false}
                    placeholder={item["placeholder"] || item["label"]}
                    onBlur={() =>
                      item["onBlur"] !== undefined ? item["onBlur"]() : () => {}
                    }
                    onChangeText={(text) => {
                      try {
                        if (item["keyboardType"]) {
                          text = text.replace(/[^0-9]/g, "");
                        }
                        if (detailsArr["onChangeText"])
                          detailsArr["onChangeText"](item["ColumnName"], text);
                        else handleOptionPress(text, true, index);
                      } catch (e) {
                        log("Error from  ====> ", e);
                      }
                    }}
                    value={item["ColumnValue"]?.toString()}
                    onFocus={(event) => {
                      let val = item["ColumnValue"],
                        text =
                          cleanValue(val) == 0
                            ? ""
                            : val?.toString()?.replaceAll("$", "");
                      if (detailsArr["onChangeText"])
                        detailsArr["onChangeText"](item["ColumnName"], text);
                      else handleOptionPress(text, true, index);
                    }}
                  />
                ) : item["type"] === 3 ? (
                  <>
                    <Dropdown
                      isValid={item["isValid"]}
                      label={item["label"]}
                      options={[
                        { label: "Select", value: -99 },
                        ...item["Option"],
                      ]}
                      value={
                        item["isMap"]
                          ? item["Option"].filter(
                              (e) => e["value"] == item["ColumnValue"]
                            )[0]?.label
                          : item["ColumnValue"]
                      }
                      onSelect={(item_) => {
                        if (detailsArr["onChangeText"])
                          detailsArr["onChangeText"](
                            item["ColumnName"],
                            item_["value"]
                          );
                        else
                          handleOptionPress(
                            item_["value"],
                            null,
                            null,
                            item["ColumnName"]
                          );
                      }}
                      placeholder={item["placeholder"] || ""}
                      isMap={item["isMap"]}
                    />
                  </>
                ) : item["type"] === 1 ? (
                  <>
                    <View>
                      <View
                        style={
                          item["widthOption"] !== undefined
                            ? {
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }
                            : { flex: 1 }
                        }
                      >
                        {item["Options"]?.map((item_, index) => (
                          <Option
                            key={index}
                            style={
                              item["widthOption"] !== undefined
                                ? { width: item["widthOption"] }
                                : {}
                            }
                            text={item_["text"]}
                            value={item_["value"] === item["ColumnValue"]}
                            onPress={() => {
                              if (detailsArr["onChangeText"])
                                detailsArr["onChangeText"](
                                  item["ColumnName"],
                                  item_["value"]
                                );
                              else
                                handleOptionPress(
                                  item_["value"],
                                  null,
                                  null,
                                  null,
                                  null
                                );
                            }}
                          />
                        ))}
                      </View>
                    </View>
                  </>
                ) : item["type"] === 6 ? (
                  <>
                    <CheckBoxSelection
                      isMultiple={item["isMultiple"] || false}
                      options={item["Option"]}
                      value={
                        item["isMap"]
                          ? item["Option"].filter(
                              (e) => e["value"] == item["ColumnValue"]
                            )[0]?.label
                          : item["ColumnValue"]
                      }
                      onChange={(value) => {
                        if (detailsArr["onChangeText"])
                          detailsArr["onChangeText"](item["ColumnName"], value);
                        else
                          handleOptionPress(
                            value,
                            null,
                            null,
                            item["ColumnName"]
                          );
                      }}
                    />
                  </>
                ) : item["type"] === 4 && item["isAddressAutocomplete"] ? (
                  android || ios ? (
                    <AddressAutocompleteApp
                      label={item["label"]}
                      value={item["ColumnValue"]?.toString() || ""}
                      placeholder={item["placeholder"] || item["label"]}
                      validate={item["isValid"]}
                      forceValidation={item["forceValidation"]}
                      onChange={(text) => {
                        handleOptionPress(
                          text,
                          true,
                          index,
                          item["ColumnName"]
                        );
                      }}
                      onAddressSelect={item["onAddressSelect"]}
                      onBlur={() =>
                        item["onBlur"] !== undefined
                          ? item["onBlur"]()
                          : () => {}
                      }
                      // disabled={LockLoanApp == 1}
                    />
                  ) : (
                    <AddressAutocomplete
                      label={item["label"]}
                      value={item["ColumnValue"]?.toString() || ""}
                      placeholder={item["placeholder"] || item["label"]}
                      validate={item["isValid"]}
                      forceValidation={item["forceValidation"]}
                      onChange={(text) => {
                        handleOptionPress(
                          text,
                          true,
                          index,
                          item["ColumnName"]
                        );
                      }}
                      onAddressSelect={item["onAddressSelect"]}
                      onBlur={() =>
                        item["onBlur"] !== undefined
                          ? item["onBlur"]()
                          : () => {}
                      }
                      // disabled={LockLoanApp == 1}
                    />
                  )
                ) : (
                  <></>
                )}
              </View>
            ))}
          </View>
          {detailsArr["footerButton"] && detailsArr["footerButton"]}

          {detailsArr["removeContent"] && detailsArr["isRemove"] && (
            <>
              <Separator />
              {detailsArr["removeContent"]}
            </>
          )}
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  inputBoxContainer: {
    flexDirection: "row",
    borderColor: "gray",
    borderWidth: 1,
    borderRadius: 8,
    padding: 10,
    marginBottom: 20,
  },
  iconButtonContainer: {
    backgroundColor: "#1a63ad",
    borderRadius: 25,
    height: 45,
    paddingVertical: 10,
    paddingHorizontal: 10,
    marginTop: 8,
    paddingTop: web ? "5px" : null,
    alignSelf: "flex-start",
    padding: 30,
  },
  optionContainer: {
    backgroundColor: "#f2f5f8",
    borderRadius: 17,
    paddingVertical: web ? 6 : 3,
    paddingHorizontal: 12,
    borderColor: "#606060",
    borderWidth: 1,
    marginTop: -8,
    position: "absolute",
  },
  optionText: {
    fontSize: web ? 12 : 10,
    color: "#787878",
    width: "100%",
    textAlign: "center",
    flex: 1,
    flexShrink: 1,
  },
  iconButtonText: {
    fontSize: 18,
    color: "#fff",
  },
  inputBoxLabel: {
    position: "absolute",
    backgroundColor: "#fff",
    top: -12,
    left: 3,
    fontSize: 14,
    color: "gray",
    paddingHorizontal: 3,
  },
  inputBox: {
    ...{
      borderWidth: 0,
      borderRadius: 5,
      fontSize: web ? 15 : 16,
      backgroundColor: "rgba(0,0,0,.04)",
      color: "#51575d",
      width: "100%",
      padding: 5,
    },
  },
});

export default Income;
